<!-- main app container -->
<ngx-loading-bar [includeSpinner]='false' height='3px' color="#0b2244"></ngx-loading-bar>
<app-alert></app-alert>
<router-outlet *ngIf="showContent"></router-outlet>